import { Digit } from 'types';

const getDigitFromChar = (c: string): Digit => {
  return (c.charCodeAt(0) % 9) as Digit;
};

export default getDigitFromChar;
